'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import RootLayouts from '@/layouts/Rootlayouts';

import CourseLevel from '@/components/course/CourseLevel';
import CourseListingPage from '@/components/course/CourseListingPage';

const CourseListingPageComponent = ({ courseId, course, specialization, filter, queryParams }: any) => {
  const CourseListSection = dynamic(() => import('@/components/course/CourseListComponent'), { ssr: false });

  return (
    <RootLayouts>
      {/* <TopExploreSection
        title="Courses"
        data={topCourseData
          ?.filter((course: any) => course?.page_data?.length > 0)
          ?.map((course: any, index: number) => ({
            name: course?.abbreviation,
            url: course?.course_url,
            id: `${course?.id}-${index}`,
          }))}
        linkPrefix="/courses"
        linkSuffix="/course-info"
        className="bg-gray-200 py-1"
        textColor="text-black"
      /> */}
      <section className="mb-10 mt-24 min-h-40 lg:mt-28">
        {/* /courses/course-after-10th */}
        {filter === 'course-level' ? (
          <CourseLevel streamData={course?.results} courseId={courseId} />
        ) : (
          <section className="mx-auto font-poppins lg:w-[85%] lg:max-w-screen-xl 2xl:w-4/5">
            <p className="text-sm md:text-base">
              Showing <span className="font-semibold text-primary">{course?.pagination?.total}</span> Courses
            </p>
            <CourseListingPage courseData={course?.results} specializationData={specialization} />
            <CourseListSection queryParam={queryParams} pageCount={course?.pagination?.pageCount} />
          </section>
        )}
      </section>
    </RootLayouts>
  );
};

export default CourseListingPageComponent;
